import React from 'react';
import '../less/cashbackUA.less';
import Hero from '../../../../auxiliary-components/shared/HeroBlock';
import QuestionsAdminNew from '../../../../auxiliary-components/shared/QuestionsAdminNew';
import FilesForDownloadNew from "../../../../auxiliary-components/shared/FilesForDownloadNew";
import TextAboveFooterNew from "../../../../auxiliary-components/shared/TextAboveFooterNew";
import FAQStorybook from '@abank/abank-faq';
import hero_img from '../img/hero_img.png';
import CardOrderModal from '../../../../auxiliary-components/CardOrderModal';
import advantages_img_1 from '../img/advantages_img_1.png';
import advantages_img_2 from '../img/advantages_img_2.png';
import Advantages from '../../../../auxiliary-components/shared/AdvantagesBlock';
import { cahsbackUATariffs } from '../../../../services/urls/urls';
import Tariffs from '../../../../auxiliary-components/shared/TariffsBlock';
import AdditionalProduct from '../../../../auxiliary-components/shared/AdditionalProductBlock';
import InfoBlock from '../../../../auxiliary-components/shared/InfoBlock';
import tariffsData from '../enums/tariffs_data.json';
import additionalCards from '../enums/additional_cards_data.json';
import { filterByEnvironment } from '../../../../helpers/utils/environmentFilter';
import Tabs from '../../../../auxiliary-components/shared/Tabs';
import { howToGetCardItems } from '../../enums/howToGetCardData';
import HowToBlockNew from '../../../../auxiliary-components/shared/HowToBlockNew';

export default function template() {
    const page = 'cashback-ua-card-new';

    const tabs = [{tab: 'tariffs', title: 'CASHBACK_UA_CARD_NEW_TABS_TITLE_01'},
          {tab: 'how-to-get-card', title: 'CARDS_COMMON_NEW_HOW_TO_GET_CARD_TAB_TITLE'}];

    const hero_data = {
      title: 'CASHBACK_UA_CARD_NEW_HERO_TITLE',
      text: 'CASHBACK_UA_CARD_NEW_HERO_TEXT',
      link: {
        text: "CASHBACK_UA_CARD_NEW_HERO_BTN",
        onClick: () => this.toggleModal(),
      },
      cards: [
        {
          title: 'CASHBACK_UA_CARD_NEW_CARDS_HERO_TITLE_01',
          text: 'CASHBACK_UA_CARD_NEW_CARDS_HERO_TEXT_01',
        },
        {
          title: 'CASHBACK_UA_CARD_NEW_CARDS_HERO_TITLE_02',
          text: 'CASHBACK_UA_CARD_NEW_CARDS_HERO_TEXT_02',
        },
        {
          title: 'CASHBACK_UA_CARD_NEW_CARDS_HERO_TITLE_03',
          text: 'CASHBACK_UA_CARD_NEW_CARDS_HERO_TEXT_03',
        }
      ]
    };

    const advantagesItems = [
      {
        img: advantages_img_1,
        title: 'CASHBACK_UA_CARD_NEW_CARDS_ADVANTAGES_TITLE_01',
        text: 'CASHBACK_UA_CARD_NEW_CARDS_ADVANTAGES_TEXT_01',
      },
      {
        img: advantages_img_2,
        title: 'CASHBACK_UA_CARD_NEW_CARDS_ADVANTAGES_TITLE_02',
        text: 'CASHBACK_UA_CARD_NEW_CARDS_ADVANTAGES_TEXT_02',
      }
    ];

    const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

    return (
      <div className="cashback-ua-card-new">
        <Hero
          data={hero_data}
          img={hero_img}
          page={page}
        />
        <div className="content">
          {!this.state.faqTab ? (
            <>
              <div>
                <InfoBlock 
                  title={'CASHBACK_UA_CARD_NEW_INFO_TITLE_1'}
                  middleText={'CASHBACK_UA_CARD_NEW_INFO_TEXT_MIDDLE_1'}
                  text={'CASHBACK_UA_CARD_NEW_INFO_TEXT_1'}
                />
              </div>
              <Advantages
                items={advantagesItems}
                title={'CASHBACK_UA_CARD_NEW_ADVANTAGES_TITLE'}
              />
              <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab}>
                <Tariffs
                  items={tariffsData}
                  title={'CASHBACK_UA_CARD_NEW_CARDS_TARIFFS_TITLE'}
                  btnLink={cahsbackUATariffs}
                  btnText={'CASHBACK_UA_CARD_NEW_CARDS_TARIFFS_BTN'}
                  page={page}
                />
                <HowToBlockNew
                  title={'CARDS_COMMON_NEW_HOW_TO_GET_CARD_TITLE'}
                  items={howToGetCardItems}
                />
              </Tabs>
              <AdditionalProduct
                items={additionalCards}
                title={'CASHBACK_UA_CARD_NEW_ADDITIONAL_PRODUCT_TITLE'}
                page={page}
              />
              <QuestionsAdminNew
                title={this.l10n('CASHBACK_UA_CARD_NEW_FAQ_STORYBOOK_TITLE')}
                widget={questionsWidget}
                toggleFaqTab={this.toggleFaqTab}
                page={page}
              />
              <FilesForDownloadNew
                widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
              />
              <TextAboveFooterNew
                widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')}
              />
            </>
          ) : (
            <FAQStorybook
              widget={questionsWidget}
              title={this.l10n('CASHBACK_UA_CARD_NEW_FAQ_STORYBOOK_TITLE')}
              btnText={this.l10n('CASHBACK_UA_CARD_NEW_FAQ_STORYBOOK_BTN_TEXT')}
              onBtnClick={this.toggleFaqTab}
              filterByEnvironment={filterByEnvironment}
            />
          )}
        </div>
        {this.state.showModal ? 
          <CardOrderModal closeModal={this.toggleModal} product={"cashback_ua"} isOpen={this.state.showModal}/> : ''
        }
      </div>
    );
}
